module.exports = __webpack_public_path__ + "img/xuanchuantu.ec7bc079.png";